import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";

export default function Perche() {
  return (
    <div className="paper-bg" data-testid="perche-page">
      <PublicNav />

      {/* HERO — numero-manifesto */}
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-20">
        <div className="label-uppercase mb-6">Perché Pronto alla Vendita</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-4xl">
          Il bene più grande che possiedi<br className="hidden md:block" /> lo vendi alla cieca.
        </h1>

        <div className="mt-20 md:mt-28 flex flex-col md:flex-row md:items-end gap-8 md:gap-16 border-t border-[#E6E4E0] pt-14">
          <div
            className="font-serif text-[#7D2E3F] leading-[0.85] tracking-[-0.03em] text-[10rem] md:text-[16rem] lg:text-[20rem]"
            data-testid="perche-numero-manifesto"
          >
            45%
          </div>
          <p className="text-sm md:text-base text-[#5C5657] max-w-sm mb-6 md:mb-10">
            della ricchezza delle famiglie italiane è dentro un immobile.
            <br />
            <span className="text-xs text-[#5C5657]/70 tracking-wide">Fonte: Banca d'Italia–ISTAT.</span>
          </p>
        </div>
      </section>

      {/* CORPO EDITORIALE */}
      <section className="border-t border-[#E6E4E0]">
        <div className="max-w-[880px] mx-auto px-6 md:px-10 py-24 space-y-20">

          <div>
            <p className="font-serif text-2xl md:text-[28px] leading-[1.55] text-[#3A3D42]">
              Quasi metà di tutto quello che hai messo da parte in una vita, in una cosa sola.
              Eppure è l'unico bene che, quando decidi di venderlo, metti sul mercato senza sapere
              davvero cosa vendi. Un'auto la controlli prima. Un'azienda la fai valutare.
              La casa — che vale metà del tuo patrimonio — la esponi e speri che vada bene.
            </p>
          </div>

          <div className="border-l-2 border-[#7D2E3F] pl-6 md:pl-8">
            <div className="label-uppercase text-[#7D2E3F] mb-3">01</div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight text-[#3A3D42]">
              Il problema non è avere un problema.<br className="hidden md:block" /> È scoprirlo troppo tardi.
            </h2>
            <p className="text-base md:text-lg text-[#5C5657] mt-6 leading-relaxed">
              Ogni immobile ha qualcosa da sistemare: una difformità, un impianto non a norma,
              una pratica catastale rimasta indietro. Non è questo che ti fa perdere valore.
              Lo perdi quando quel qualcosa emerge a trattativa avviata — dal notaio, in fase
              di rogito, quando il compratore ha già in mano il potere. A quel punto non tratta
              più sul prezzo. Tratta sull'incertezza. E l'incertezza si paga sempre.
            </p>
          </div>

          <div className="border-l-2 border-[#7D2E3F] pl-6 md:pl-8">
            <div className="label-uppercase text-[#7D2E3F] mb-3">02</div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight text-[#3A3D42]">
              Il mercato non penalizza i problemi.<br className="hidden md:block" /> Penalizza l'incertezza.
            </h2>
            <p className="text-base md:text-lg text-[#5C5657] mt-6 leading-relaxed">
              Un immobile con criticità note, dichiarate e quantificate prima della trattativa
              vale più di un immobile "pulito" su cui salta fuori una sorpresa a metà strada.
              Il compratore che sa cosa compra, tratta sui fatti. Il compratore che scopre, tratta
              sulla paura — e la paura la fai pagare a te.
            </p>
          </div>

          <div className="border-l-2 border-[#7D2E3F] pl-6 md:pl-8">
            <div className="label-uppercase text-[#7D2E3F] mb-3">03</div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight text-[#3A3D42]">
              Sapere cosa non va è il minimo.<br className="hidden md:block" /> Sapere cosa fare vale di più.
            </h2>
            <p className="text-base md:text-lg text-[#5C5657] mt-6 leading-relaxed">
              Dichiarare una criticità la toglie dalle sorprese. Ma non tutte vanno lasciate così
              come sono. Alcune conviene risolverle prima — perché sistemarle costa una frazione
              di quello che ti farebbero perdere in trattativa. Altre basta quantificarle: sapere
              quanto pesano, in euro, e scaricarle sul prezzo in modo motivato invece di subirle
              come sconto. La valorizzazione è questo. Non alzare il prezzo: togliere all'immobile
              le ragioni per cui verrebbe svalutato. Un piano preciso — cosa si fa prima della
              vendita, cosa si dichiara, cosa si sconta e di quanto — così il valore che chiedi
              è un valore che puoi spiegare.
            </p>
          </div>

          <div className="border-l-2 border-[#7D2E3F] pl-6 md:pl-8">
            <div className="label-uppercase text-[#7D2E3F] mb-3">04</div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight text-[#3A3D42]">
              Pronto alla Vendita esiste per questo.
            </h2>
            <p className="text-base md:text-lg text-[#5C5657] mt-6 leading-relaxed">
              Per portare l'immobile sul mercato già in ordine: verificato, con le criticità
              dichiarate e valorizzato — prima che sia la trattativa a deciderlo al posto tuo.
              Non è una promessa. È un esito.
            </p>
          </div>

          <div className="pt-6">
            <Link
              to="/form"
              data-testid="perche-cta"
              className="btn-primary inline-block"
            >
              Scopri se la tua casa può entrare
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
